import { TranslatedCopy } from '../../intl/TranslatedCopy';

export const SECTION_DETAIL = 'detail';
export const SECTION_SELECT = 'select';
export const SECTION_FINALIZE = 'finalize';
export const SECTION_SUBMITTED = 'submitted';

export const PER_PAGE = 5;

export const STATUS_APPROVED = 'APPROVED';
export const STATUS_CANCELLED = 'CANCELLED';
export const STATUS_COMPLETE = 'COMPLETE';
export const STATUS_CONFIRMED = 'CONFIRMED';
export const STATUS_DENIED = 'DENIED';
export const STATUS_IN_PROCESS = 'IN PROCESS';
export const STATUS_OPEN = 'OPEN';
export const STATUS_PARTIALLY_SHIPPED = 'PARTIALLY SHIPPED';
export const STATUS_RECEIVED = 'RECEIVED';
export const STATUS_SHIPPED = 'SHIPPED';
export const STATUS_SUBMITTED = 'SUBMITTED';
export const STATUS_FAILED = 'FAILED';
export const STATUS_CLOSED = 'CLOSED';
export const RETURNS_ERROR_CODE = 'E007';

export const ORDER_STATUS_OPTIONS = [
  STATUS_CANCELLED,
  STATUS_FAILED,
  STATUS_OPEN,
  STATUS_PARTIALLY_SHIPPED,
  STATUS_SHIPPED,
  STATUS_SUBMITTED
];

export const RETURN_STATUS_OPTIONS = [
  STATUS_APPROVED,
  STATUS_CANCELLED,
  STATUS_COMPLETE,
  STATUS_DENIED,
  STATUS_IN_PROCESS,
  STATUS_RECEIVED,
  STATUS_SUBMITTED
];

export const MANA_RETURN_STATUS_OPTIONS = [STATUS_SUBMITTED, STATUS_APPROVED, STATUS_CANCELLED, STATUS_CLOSED];

export const PAYMENT_METHOD_BILLABLE = 'BILLABLE';
export const PAYMENT_METHOD_COMP_CASH = 'COMP-CASH';
export const PAYMENT_METHOD_COMP_UNIT = 'COMP-UNIT';
export const PAYMENT_METHOD_FREE = 'FREE';

export const RETURN_REASONS = [
  {
    label: new TranslatedCopy({ id: 'orderreturns.returnReason.option1' }).toString(),
    value: '120'
  },
  {
    label: new TranslatedCopy({ id: 'orderreturns.returnReason.option2' }).toString(),
    value: '124'
  },
  {
    label: new TranslatedCopy({ id: 'orderreturns.returnReason.option3' }).toString(),
    value: '125'
  },
  {
    label: new TranslatedCopy({ id: 'orderreturns.returnReason.option4' }).toString(),
    value: '126'
  },
  {
    label: new TranslatedCopy({ id: 'orderreturns.returnReason.option5' }).toString(),
    value: '128'
  },
  {
    label: new TranslatedCopy({ id: 'orderreturns.returnReason.option6' }).toString(),
    value: '220'
  }
];

const todaysDate = new Date();
const month = todaysDate.getMonth();
const day = todaysDate.getDate();

export const TODAY = `${month.toString().length === 1 ? `0${month}` : month}/${
  day.toString().length === 1 ? `0${day}` : day
}/${todaysDate.getFullYear()}`;
